import { coreApi } from 'src/api/config';
import fetchCustomConsentConfiguration from 'src/api/core/CustomConsentConfigurations/fetchCustomConsentConfiguration';
import fetchCustomConsentAgreements from 'src/api/core/CustomConsentAgreements/fetchCustomConsentAgreements';
import generateCustomConsentBatchBody from './generateCustomConsentBatchBody';
import { NH_REFERRAL_CONSENT_CODE, NH_CONSENT_CONFIGURATION_TYPE, NH_DATA_SHARE_CONSENT_CODE } from './constants';

const createCustomConsentBatchDocument =
  async ({
    contactId,
    selectedReferralIds,
    unselectedReferralIds = [],
    referralSpecificAgreementAnswer,
    referralStateShareAgreementAnswer,
    documentsFileList,
  }) => {
    const [specificAgreementConfiguration, stateShareAgreementConfiguration] = await Promise.all([
      fetchCustomConsentConfiguration({
        consentCode: NH_REFERRAL_CONSENT_CODE,
        consentType: NH_CONSENT_CONFIGURATION_TYPE,
      }),
      fetchCustomConsentConfiguration({
        consentCode: NH_DATA_SHARE_CONSENT_CODE,
        consentType: NH_CONSENT_CONFIGURATION_TYPE,
      }),
    ]);

    const [specificAgreement, stateShareAgreement] = await Promise.all([
      fetchCustomConsentAgreements({
        configurationId: specificAgreementConfiguration.id, language: 'en',
      }),
      fetchCustomConsentAgreements({
        configurationId: stateShareAgreementConfiguration.id, language: 'en',
      }),
    ]);

    const body = generateCustomConsentBatchBody({
      selectedReferralIds,
      unselectedReferralIds,
      consentMethod: 'written',
      submissionMethod: 'file_upload',
      specificAgreement: {
        id: specificAgreement.id, status: referralSpecificAgreementAnswer,
      },
      stateShareAgreement: {
        id: stateShareAgreement.id, status: referralStateShareAgreementAnswer,
      },
    });

    const response = await coreApi.batchCreateCustomConsents(contactId, body);
    const customConsentCreated = response.data.data;

    // Uploads one file per custom consent created
    const uploadFiles = customConsentCreated
      .map((customConsent) => coreApi.uploadFile('custom_consent', customConsent.id, documentsFileList[0]));
    await Promise.all(uploadFiles);

    return response;
  };

export default createCustomConsentBatchDocument;
